import './DeleteNote.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Error from '../Error/Error';
import Notes from '../../api/controllers/Notes/Notes';

// General DeleteNote Component
const DeleteNote = ({ noteId, refetchNotes, setModalOpen }) => {
  const [error, setError] = useState();

  const deleteNote = () => {
    Notes.destroy(noteId)
      .then(() => {
        refetchNotes();
        setModalOpen(false);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="delete_note_container">
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="message">Are you sure?</div>
      <div className="delete_note_buttons">
        <button className="cancel_button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>
        <button className="ok_button" onClick={() => deleteNote()}>
          OK
        </button>
      </div>
    </div>
  );
};

DeleteNote.propTypes = {
  noteId: PropTypes.number,
  refetchNotes: PropTypes.func,
  setModalOpen: PropTypes.func,
};

export default DeleteNote;
